export default {
	UPDATE_SEARCH_TEXT: "search/UPDATE_SEARCH_TEXT",
	SAVE_SEARCH_FILTER: "search/SAVE_SEARCH_FILTER",
	UPDATE_SEARCH_RESULTS: "search/UPDATE_SEARCH_RESULTS",
	UPDATE_SEARCH_HISTORY: "search/UPDATE_SEARCH_HISTORY",
	UPDATE_ARCHIVED_DATA_SEARCH_TEXT: "search/UPDATE_ARCHIVED_DATA_SEARCH_TEXT"
}
